import { IIconProps } from '~/types';
const CadFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.25}
      y={0.25}
      width={27.5}
      height={19.5}
      rx={1.75}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
    />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={1.75}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
      />
    </mask>
    <g mask="url(#a)" fill="#FF3131">
      <path d="M20 0h8v20h-8z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20h8V0H0zM16.113 9.222a.333.333 0 0 1-.563-.301L16 6.667l-1.333.667-.666-2-.667 2-1.333-.667.45 2.254a.333.333 0 0 1-.562.3l-.32-.318a.333.333 0 0 0-.47 0l-.432.43-1.333-.666.667 1.333-.431.431a.333.333 0 0 0 0 .472l1.764 1.764h2l.333 2h.667l.333-2h2l1.765-1.764a.333.333 0 0 0 0-.472l-.431-.43.666-1.334-1.333.667-.431-.431a.333.333 0 0 0-.471 0z"
      />
    </g>
  </svg>
);
export default CadFlag;
